import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class CodeService {

  constructor(private firestore: AngularFirestore) { }

  public getCodeById(id): any {
    return this.firestore.collection('codes').doc(id).valueChanges({ idField: 'id' });
  }

  public getCodeByCode(code): any {
    return this.firestore.collection('codes',
    ref => ref.where('code', '==', code)).get().toPromise();
  }

  public updateCodeStatus(id, stateCode): any {
    return this.firestore.collection('codes').doc(id).update({
      state: stateCode,
    });
  }
  public updateCodeStatusToUsed(id, stateCode, alumno, tutor): any {
    return this.firestore.collection('codes').doc(id).update({
      state: stateCode,
      student : firebase.firestore().doc(`/users/${alumno.id}`),
      tutor : firebase.firestore().doc(`/users/${tutor.id}`),
      center: firebase.firestore().doc(`/centers/${alumno.centroId}`),
    });
  }
  public updateCodeStatusToNoUsed(id, stateCode): any {
    return this.firestore.collection('codes').doc(id).update({
      state: stateCode,
      student : firebase.firestore.FieldValue.delete(),
      tutor : firebase.firestore.FieldValue.delete(),
      center: firebase.firestore.FieldValue.delete(),
    });
  }

}
